<p class="title">
    Vessel Performance

    <mat-icon class="titleIcon">
      chevron_right
    </mat-icon>

    Commercial Performance

    <mat-icon class="titleIcon">
      chevron_right
    </mat-icon>

    TCP Graph
  </p>
<div class="tcpGraph" [ngClass]="{ 'dark-theme': isDarkMode() }">
  <div class="header-container">
    <div class="segment-selector">
      <label for="typeOfShipDropdown"> Type of Ship: </label>
      <select
        id="typeOfShipDropdown"
        [(ngModel)]="selectedTypeOfShip"
        (change)="onTypeOfShipChange()"
      >
        <option
          *ngFor="let option of typeofshipOptions"
          [ngValue]="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- SEGMENT -->

    <div class="segment-selector">
      <label for="segmentDropdown"> Segment: </label>

      <select
        id="segmentDropdown"
        [(ngModel)]="selectedSegment"
        (change)="loadChartData()"
      >
        <option *ngFor="let seg of segmentOptions" [ngValue]="seg.value">
          {{ seg.label }}
        </option>
      </select>
    </div>

    <!-- CONDITION -->

    <div class="segment-selector">
      <label for="conditionDropdown"> Condition: </label>

      <select
        id="conditionDropdown"
        [(ngModel)]="selectedCondition"
        (change)="loadChartData()"
      >
        <option *ngFor="let cond of conditionOptions" [ngValue]="cond">
          {{ cond }}
        </option>
      </select>
    </div>

    <!-- SPEED MULTI SELECT -->

    <div class="segment-selector">
      <label for="speedDropdown"> Speed: </label>

      <div class="multi-select-dropdown" id="speedDropdown">
        <!-- SELECT BOX -->

        <div
          class="speed-select-box"
          tabindex="0"
          (click)="toggleSpeedDropdown()"
          (blur)="speedDropdownOpen = false"
        >
          <span
            class="speed-selected-value"
            [class.placeholder]="!selectedSpeedLabels"
          >
            {{ selectedSpeedLabels || "Select Speeds" }}
          </span>

          <mat-icon class="speed-dropdown-icon">
            {{
              speedDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}
          </mat-icon>
        </div>

        <!-- DROPDOWN OPTIONS -->

        <div
          class="dropdown-list"
          *ngIf="speedDropdownOpen"
          (mousedown)="$event.preventDefault()"
        >
          <label *ngFor="let spd of speedOptions" class="dropdown-item">
            <input
              type="checkbox"
              [checked]="selectedSpeed.includes(spd)"
              (change)="onSpeedCheckboxChange($event, spd)"
            />

            <span>
              {{ spd }}
            </span>
          </label>
        </div>
      </div>
    </div>

    <!-- CLIENT -->

    <div class="segment-selector" *ngIf="(username === 'Meraki - Operations' && subusername !== 'demo')">
      <label for="clientDropdown"> Client: </label>

      <select
        id="clientDropdown"
        [(ngModel)]="selectedClient"
        (change)="loadChartData()"
      >
        <option *ngFor="let item of clientOptions" [ngValue]="item">
          {{ item }}
        </option>
      </select>
    </div>

    <!-- CLEAR BUTTON -->

    <div>
      <button type="button" class="clear-button" (click)="clearSelections()">
        <mat-icon> clear_all </mat-icon>

        Clear
      </button>
    </div>

    <!-- SORT BUTTONS -->

    <div class="chart-action-buttons">
      <button
        type="button"
        class="sort-button"
        (click)="sortByConsumptionChart()"
      >
        Sort by Consumption

        <mat-icon class="sortIcon"> swap_vert </mat-icon>
      </button>

      <button type="button" class="sort-button" (click)="azSortChart()">
        Sort Alphabetical

        <mat-icon class="sortIcon"> swap_vert </mat-icon>
      </button>
    </div>
  </div>

  <!-- ===============================
       TCP GRAPH
  ================================ -->
<div *ngIf="isLoadingChart" class="skeleton-chart-container">
    <div class="skeleton skeleton-chart"></div>
  </div>
  <div *ngIf="!isLoadingChart" [chart]="chartOptions" class="graphId"></div>
</div>
